import { Injectable } from '@angular/core';
import { ContainerService } from '@3d-scene/model3d/container.service';
import { LoadConnectionTextureProcessor } from '@3d-scene/processor/load-connection-texture.processor';
import { TextureConnectionUtils } from '@3d-scene/processor/texture-connection-utils';
import { ConnectionCubeSearchHelper } from '@article/components/connections/connection-creation/search/connection-cube-search.helper';
import { DirectPrintingHelper } from '@article/helper/direct-printing/direct-printing.helper';
import { InsertArticleHelperFactory } from '@article/helper/insert-article-helper.factory';
import { ArticleManager } from '@article/manager/article.manager';
import { ProjectModel } from '@project/model/project.model';
import { AlertHelper } from '@shared/alert/alert.helper';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';
import { UndoRedoUtils } from '@shared/undo/undo-redo-utils';
import { UndoRedoHelper } from '@shared/undo/undo-redo.helper';
import { OpenLabelEditorHelper } from '../../label/label-editor/service/open-label-editor.helper';
import { ArticlePrepareProcessorRegistry } from '../processor/prepare/article-prepare-processor-registry';
import { ArticleConnectProcessorRegistry } from '../processor/prepare/connect/article-connect-processor-registry';
import { ArticleCreationService } from '../service/article-creation.service';
import { InsertArticleService } from '../service/insert-article.service';
import { InsertArticleUtils } from '../util/insert-article-utils';
import { ArticleCreationManager } from './article-creation.manager';
import { ProjectArticleService } from '@project/service/project-article.service';
import { SelectionModelService } from '../service/selection-model.service';
import { DetachArticleUsageService } from '@project/service/detach-article-usage.service';
import { ConnectionInfoService } from '@3d-scene/model3d/service/connection-info.service';
import { ChangeLtlArticleService } from '@article/ltl/change-ltl-article.service';

@Injectable({ providedIn: 'root' })
export class ArticleCreationManagerFactory {
  constructor(
    private alertHelper: AlertHelper,
    private projectModel: ProjectModel,
    private projectArticleService: ProjectArticleService,
    private selectionModelService: SelectionModelService,
    private undoRedoHelper: UndoRedoHelper,
    private articleManager: ArticleManager,
    private prepareProcessorRegistry: ArticlePrepareProcessorRegistry,
    private loadConnectionTextureProcessor: LoadConnectionTextureProcessor,
    private localeResourceManager: LocaleResourceManager,
    private directPrintingHelper: DirectPrintingHelper,
    private connectProcessorRegistry: ArticleConnectProcessorRegistry,
    private openLabelEditorHelper: OpenLabelEditorHelper,
    private undoRedoUtils: UndoRedoUtils,
    private componentUtils: ContainerService,
    private onnectionInfoService: ConnectionInfoService,
    private textureConnectionUtils: TextureConnectionUtils,
    private connectionCubeSearchHelper: ConnectionCubeSearchHelper,
    private insertArticleHelperFactory: InsertArticleHelperFactory,
    private insertArticleUtils: InsertArticleUtils,
    private articleCreationService: ArticleCreationService,
    private insertArticleService: InsertArticleService,
    private detachArticleUsageService: DetachArticleUsageService,
    private changeLtlArticleService: ChangeLtlArticleService,
  ) {}

  public getNewInstance(): ArticleCreationManager {
    return new ArticleCreationManager(
      this.alertHelper,
      this.projectModel,
      this.projectArticleService,
      this.selectionModelService,
      this.undoRedoHelper,
      this.articleManager,
      this.prepareProcessorRegistry,
      this.loadConnectionTextureProcessor,
      this.localeResourceManager,
      this.directPrintingHelper,
      this.connectProcessorRegistry,
      this.openLabelEditorHelper,
      this.undoRedoUtils,
      this.componentUtils,
      this.onnectionInfoService,
      this.textureConnectionUtils,
      this.connectionCubeSearchHelper,
      this.insertArticleHelperFactory,
      this.insertArticleUtils,
      this.articleCreationService,
      this.insertArticleService,
      this.detachArticleUsageService,
      this.changeLtlArticleService,
    );
  }
}
